// src/pages/PrivacyPolicy.jsx
import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { motion } from "framer-motion";
import "../styles/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [privacyContent, setPrivacyContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}privacy_policy_content.php`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({}),
          }
        );

        const data = await response.json();
        console.log("Privacy Policy API Response:", data);

        if (data?.head?.code === 200 && data.body.length > 0) {
          setPrivacyContent(data.body[0].content);
        } else {
          setPrivacyContent("");
        }
      } catch (error) {
        console.error("Failed to fetch Privacy Policy:", error);
        setPrivacyContent("");
      } finally {
        setLoading(false);
      }
    };

    fetchPrivacyPolicy();
  }, [API_BASE_URL]);

    // Page loader
  const PageLoader = () => {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "#ffffff",
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div
        className="spinner-border"
        role="status"
        style={{ width: "3.5rem", height: "3.5rem", color: "#f64a1aff" }}
      />
      <p className="mt-3 fw-semibold">Loading Privacy Policy...</p>
    </div>
  );
};

  return (
    <>
    {loading && <PageLoader />}
    
    <div style={{ paddingTop: "60px", paddingBottom: "30px" }}>
      
      {/* HERO SECTION */}
      <motion.section
        className="text-center d-flex align-items-center justify-content-center"
        style={{
          minHeight: "22vh",
          background: "#0b2747",
          color: "white",
          padding: "40px 20px",
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="container">
          <motion.h1
            className="fw-bold"
            initial={{ y: -40 }}
            animate={{ y: 0 }}
            transition={{ duration: 1 }}
          >
            Privacy Policy
          </motion.h1>

          <motion.p
            className="lead mt-3"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3, duration: 1 }}
          >
            Your privacy matters to us. Learn how Porvaall protects your data.
          </motion.p>
        </div>
      </motion.section>

      {/* MAIN CONTENT FROM DATABASE */}
      <div className="container mt-5">
        <div className="row">
          <div>
            {loading ? (
              <p>Loading privacy policy...</p>
            ) : privacyContent ? (
              <div
                className="privacy-content"
                dangerouslySetInnerHTML={{ __html: privacyContent }}
              />
            ) : (
              <p className="text-danger">No Privacy Policy content available.</p>
            )}

          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default PrivacyPolicy;
